import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import CustomSwitch from '../../styles/CustomSwitch';
import palette from '../../styles/palette';

const SelectionToggle = ({ label, onToggle, showBorder = false }) => {
  const styles = {
    container: {
      backgroundColor: `${palette.white}`,
      border: showBorder
        ? `1px solid ${palette.gt_grey_light_5}`
        : `1px solid ${palette.white}`,
      borderRadius: '4px',
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      padding: '1em',
    },
  };

  return (
    <Box spacing={1} sx={styles.container}>
      <Typography variant="body1" color="text.secondary" gutterBottom>
        {label}
      </Typography>
      <CustomSwitch
        onChange={onToggle}
        inputProps={{ 'aria-label': 'toggle_switch' }}
      />
    </Box>
  );
};

export default SelectionToggle;
